module.exports = __webpack_public_path__ + "7c2254646a8dd4e39ba543c5d2c7f32e.svg";